
export default function Notificationuser() {
  return (
    <div className="notification-card">
     
     <div className="section-title">
      <h3>NOTIFICATION</h3>
     </div>
      <div className="detail-row toggle-row">
        <span>Post Likes :</span>
         <p>Yes</p>
      </div>

      <div className="detail-row toggle-row">
        <span>Post Comments :</span>
       <p>Yes</p>
      </div>

      <div className="detail-row">
        <span>Follow :</span>
        <p>Yes</p>
      </div>

      <div className="detail-row">
        <span>Mentions :</span>
        <p>Yes</p>
      </div>

      <div className="detail-row">
        <span>Gifts Received :</span>
        <p>Yes</p>
      </div>


      <div className="detail-row">
        <span>Chat Message :</span>
        <p>Yes</p>
      </div>
    </div>
  );
}
